module.exports = __webpack_public_path__ + "media/not3.d3f7639c.mp4";